import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/img/tx.jpg'


const _withScopeId = n => (_pushScopeId("data-v-56f8ef98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personalInformation" }
const _hoisted_2 = { class: "user_info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_ava" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "info_name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fenpei" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "姓名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "电话", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "学校", -1))

import { defineComponent,reactive } from 'vue'
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let person=reactive({
    userInfo:{}
})
// 获取当前用户信息
person.userInfo =JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo"))));

// 退出
const router = useRouter();
let loginOut = () => {
    router.go(0);
    window.localStorage.clear();
    router.replace("/login");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_unref(person).userInfo.Account), 1),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", null, _toDisplayString(_unref(person).userInfo.Name), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("div", null, _toDisplayString(_unref(person).userInfo.Mobile), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("div", null, _toDisplayString(_unref(person).userInfo.SchoolName), 1)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "log-out",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(loginOut) && _unref(loginOut)(...args)))
    }, " 退出 ")
  ]))
}
}

})